export const certificationProcess = [
  {
    step: 1,
    title: "Registro en línea",
    description: "Creación de perfil con datos académicos y profesionales",
    duration: "15 minutos",
    status: "available"
  },
  {
    step: 2,
    title: "Carga de evidencias",
    description: "Subida de archivos en PDF, imágenes, videos o enlaces verificables",
    duration: "2-3 horas",
    status: "available"
  },
  {
    step: 3,
    title: "Evaluación académica",
    description: "Realizada por un comité internacional de expertos con retroalimentación cualitativa",
    duration: "15-30 días",
    status: "pending"
  },
  {
    step: 4,
    title: "Dictamen y certificación",
    description: "Emisión del certificado digital con validez internacional",
    duration: "5-7 días",
    status: "pending"
  },
  {
    step: 5,
    title: "Seguimiento y actualización",
    description: "Acceso a cursos, talleres y recertificación periódica",
    duration: "Continuo",
    status: "future"
  }
];

export const evaluationRubrics = [
  {
    id: 1,
    title: "Formación académica",
    description: "Evaluación de credenciales, títulos y trayectoria educativa del docente",
    weight: "10%",
    indicators: [
      "Grado académico alcanzado",
      "Especialización en el área de conocimiento",
      "Formación pedagógica complementaria",
      "Certificaciones adicionales relevantes"
    ]
  },
  {
    id: 2,
    title: "Experiencia docente",
    description: "Análisis de la práctica pedagógica demostrable y años de experiencia",
    weight: "10%",
    indicators: [
      "Años de experiencia en docencia",
      "Diversidad de contextos educativos",
      "Niveles educativos atendidos",
      "Modalidades de enseñanza (presencial, virtual, híbrida)"
    ]
  },
  {
    id: 3,
    title: "Competencia pedagógica",
    description: "Métodos y estrategias de enseñanza específicas para entornos digitales",
    weight: "15%",
    indicators: [
      "Diseño instruccional para modalidad virtual",
      "Estrategias de engagement estudiantil",
      "Metodologías activas de aprendizaje",
      "Adaptación curricular digital"
    ]
  },
  {
    id: 4,
    title: "Evaluación y mejora continua",
    description: "Sistemas de retroalimentación efectivos y mejoramiento permanente",
    weight: "10%",
    indicators: [
      "Instrumentos de evaluación diversificados",
      "Retroalimentación oportuna y constructiva",
      "Autoevaluación de la práctica docente",
      "Implementación de mejoras basadas en evidencia"
    ]
  },
  {
    id: 5,
    title: "Investigación y publicaciones",
    description: "Contribuciones académicas verificables en el campo educativo",
    weight: "10%",
    indicators: [
      "Artículos en revistas indexadas",
      "Participación en proyectos de investigación",
      "Ponencias en congresos académicos",
      "Capítulos de libro o libros publicados"
    ]
  }
];

export const resources = [
  {
    title: "Guías metodológicas",
    description: "Documentos detallados para cada rubro de evaluación",
    type: "guide",
    downloadLink: "#",
    lastUpdated: "2025-01-15"
  },
  {
    title: "Ejemplos de evidencias exitosas",
    description: "Casos reales de documentación que han sido aprobados",
    type: "examples",
    downloadLink: "#",
    lastUpdated: "2025-01-10"
  },
  {
    title: "Tutoriales interactivos",
    description: "Videos explicativos sobre plataformas de aprendizaje",
    type: "tutorial",
    downloadLink: "#",
    lastUpdated: "2025-01-08"
  },
  {
    title: "Manual de mejores prácticas",
    description: "Compendio de innovaciones educativas digitales",
    type: "manual",
    downloadLink: "#",
    lastUpdated: "2025-01-12"
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "Nueva convocatoria 2025 para certificación internacional",
    excerpt: "GRANA abre sus puertas a docentes de toda América Latina para obtener su certificación en competencias digitales.",
    date: "2025-01-20",
    category: "Convocatorias",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400",
    readTime: "3 min"
  },
  {
    id: 2,
    title: "Webinar: Innovaciones en la educación virtual post-pandemia",
    excerpt: "Expertos internacionales compartirán las últimas tendencias y herramientas para la enseñanza digital efectiva.",
    date: "2025-01-18",
    category: "Eventos",
    image: "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=400",
    readTime: "5 min"
  },
  {
    id: 3,
    title: "Alianza estratégica con universidades europeas",
    excerpt: "GRANA firma convenio con 15 universidades de Europa para el reconocimiento mutuo de certificaciones.",
    date: "2025-01-15",
    category: "Alianzas",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400",
    readTime: "4 min"
  }
];

export const testimonials = [
  {
    name: "Dr. María Elena Rodríguez",
    position: "Profesora Titular, Universidad Nacional de Colombia",
    country: "Colombia",
    testimonial: "La certificación GRANA me abrió puertas a oportunidades internacionales que nunca imaginé. El proceso es riguroso pero muy enriquecedor.",
    rating: 5,
    certificationYear: 2024
  },
  {
    name: "Prof. Carlos Mendoza",
    position: "Director de Educación Virtual, ITESM",
    country: "México",
    testimonial: "Como institución, reconocemos la calidad de la certificación GRANA. Nuestros docentes certificados han mejorado significativamente sus prácticas pedagógicas.",
    rating: 5,
    certificationYear: 2023
  },
  {
    name: "Dra. Ana Sofía Torres",
    position: "Especialista en Tecnología Educativa",
    country: "Argentina",
    testimonial: "El enfoque integral de GRANA en los 10 rubros me permitió identificar áreas de mejora y desarrollar nuevas competencias digitales.",
    rating: 5,
    certificationYear: 2024
  }
];

export const contactInfo = {
  emails: {
    primary: "dvallin@certification-grana.org",
    secondary: "accreditationgrana@gmail.com",
    support: "donatovalllingonzalez@gmail.com"
  },
  phones: {
    international: "USA: +1 (650) 690 2130",
    americas: "México: +52 (317) 385 1203",
    whatsapp: "+52 (317) 385 1203"
  },
  address: {
    office: "GRANA International Office",
    street: "2350 Alamo Ave, Suite 301",
    city: "Albuquerque, NM, EEUU, 87106",
    country: "Estados Unidos"
  },
  socialMedia: {
    linkedin: "https://linkedin.com/company/grana-education",
    twitter: "https://twitter.com/grana_education",
    youtube: "https://youtube.com/grana-education",
    researchgate: "https://researchgate.net/institution/grana"
  },
  officeHours: {
    weekdays: "Lunes a Viernes: 9:00 AM - 6:00 PM (GMT-6)",
    weekend: "Sábados: 10:00 AM - 2:00 PM (GMT-6)",
    closed: "Domingos: Cerrado"
  }
};

export const faqs = [
  {
    question: "¿Cuánto tiempo dura el proceso de certificación?",
    answer: "El proceso completo toma entre 30-45 días desde la presentación de documentos hasta la emisión del certificado, dependiendo de la completitud de las evidencias presentadas."
  },
  {
    question: "¿Qué validez internacional tiene el certificado?",
    answer: "El certificado GRANA es reconocido por instituciones educativas en más de 25 países y tiene validez por 5 años, renovable mediante proceso de recertificación."
  },
  {
    question: "¿Puedo aplicar si soy docente de educación básica?",
    answer: "La certificación GRANA está diseñada específicamente para docentes de educación superior y profesionales que trabajen en programas universitarios o de posgrado."
  },
  {
    question: "¿Cuál es el costo de la certificación?",
    answer: "Los costos varían según la región y se ofrecen descuentos para docentes de países en desarrollo. Contáctanos para conocer las tarifas específicas para tu país."
  }
];